module.exports = "/../../dist/frontend/images/hero-zoe-banner-mobile.webp?bde596fda0c2a251954fa93e6da26e6e";